import Axios from 'axios';
const followRedirects = require('follow-redirects');
followRedirects.maxBodyLength = 100 * 1024 * 1024; // 100 MB
Axios.defaults.maxContentLength = Infinity

export default {
	
	summaryFvc(model) {

		let url = '/linkForms/summary';
		return Axios.post(url, model)
	},

	queryLinkForms(model) {		
		let url = '/linkForms/queryLinkForms';
		return Axios.post(url, model)
	},

	downloadExcel(model) {		
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")
		return Axios.post(
			"/linkForms/downloadExcel", model, {
			responseType: 'arraybuffer'
			}
		);
	},
	
	downloadPdf(model) {
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")
		return Axios.post(
			"/linkForms/downloadPdf", model, {
			responseType: 'arraybuffer',
			}
		);
	},

	getNotes(identification) {
		
		let url = '/linkForms/queryLinkFormNotes';
		return Axios.get(url, {
			params: {
				identification: identification
			}
		})
	},

	resendLinkForms(model) {		
		let url = '/linkForms/resendLinkForm';
		return Axios.post(url, model)
	},

	urlLinkForms(model) {		
		let url = '/linkForms/urlLinkForm';
		return Axios.post(url, model)
	},

}